<template>
	<div class="chat-input-area" :class="{ 'is-dragover': isDragOver }" @dragenter.prevent="onDragEnter"
		@dragover.prevent="onDragOver" @dragleave.prevent="onDragLeave" @drop.prevent="onDrop">
		<div class="drag-mask" v-show="isDragOver">
			<span>松开鼠标以添加文件</span>
		</div>
		<div :class="['edit-container', isEmpty ? '' : 'not-empty']" contenteditable="true" @paste.prevent="onPaste"
			@keydown="onKeydown" @compositionstart="compositionFlag = true" @compositionend="onCompositionEnd"
			@input="onEditorInput" @mousedown="onMousedown" ref="content" @keyup="onKeyup" @click="onClickInput">

		</div>
		<chat-at-box @select="onAtSelect" :search-text="atSearchText" ref="atBox" :ownerId="ownerId"
			:members="groupMembers"></chat-at-box>
	</div>
</template>

<script>
import ChatAtBox from "./ChatAtBox";

export default {
	name: "ChatInput",
	components: { ChatAtBox },
	props: {
		ownerId: {
			type: Number,
		},
		groupMembers: {
			type: Array,
		},
	},
	data() {
		return {
			imageList: [],
			fileList: [],
			currentId: 0,
			atSearchText: null,
			compositionFlag: false,
			atIng: false,
			isEmpty: true,
			changeStored: true,
			blurRange: null,
			isDragOver: false,
			dragCounter: 0
		}
	},
	methods: {
		// 将粘贴文本中的表情编码 [xxx] 转为表情图片插入
		insertPastedTextWithEmoji(range, txt) {
			const emojiPattern = new RegExp(this.$emo.EMOJI_REGEX.source, 'g');
			const parts = [];
			let lastIndex = 0;
			let match;
			while ((match = emojiPattern.exec(txt)) !== null) {
				if (match.index > lastIndex) {
					parts.push({ type: 'text', content: txt.substring(lastIndex, match.index) });
				}
				const code = match[0];
				const word = this.$emo.parseEmojiWord(code);
				if (this.$emo.emoTextList.indexOf(word) !== -1) {
					parts.push({ type: 'emoji', code });
				} else {
					parts.push({ type: 'text', content: code });
				}
				lastIndex = match.index + code.length;
			}
			if (lastIndex < txt.length) {
				parts.push({ type: 'text', content: txt.substring(lastIndex) });
			}
			if (parts.length === 0) {
				parts.push({ type: 'text', content: txt });
			}
			for (let i = 0; i < parts.length; i++) {
				const part = parts[i];
				let node;
				if (part.type === 'text') {
					node = document.createTextNode(part.content);
				} else {
					node = document.createElement('img');
					node.className = 'emoji-normal no-text';
					node.dataset.emojiCode = part.code;
					node.src = this.$emo.textToUrl(part.code);
				}
				range.insertNode(node);
				if (i < parts.length - 1) {
					range.setStartAfter(node);
					range.setEndAfter(node);
				}
			}
			range.collapse(false);
		},
		onPaste(e) {
			this.isEmpty = false;
			let txt = e.clipboardData.getData('Text')
			let sel = window.getSelection()
			if (!sel || sel.rangeCount === 0) return
			let range = sel.getRangeAt(0)
			if (range.startContainer !== range.endContainer || range.startOffset !== range.endOffset) {
				range.deleteContents();
			}
			// 粘贴图片和文件时，这里没有数据
			if (txt && typeof (txt) == 'string') {
				this.insertPastedTextWithEmoji(range, txt);
				return;
			}
			let items = (e.clipboardData || window.clipboardData).items
			if (items.length) {
				for (let i = 0; i < items.length; i++) {
					let asFile = items[i].getAsFile();
					if (!asFile) {
						continue;
					}
					// 区分图片和普通文件，走对应的插入流程
					if (asFile.type && asFile.type.startsWith('image/')) {
						// 图片走图片插入流程
						this.insertMediaFile(asFile);
					} else {
						// 非图片走文件插入流程
						this.insertMediaFile(asFile);
					}
				}
			}
			range.collapse();
		},
		onDragEnter(e) {
			if (!this.hasDragFiles(e)) {
				return;
			}
			this.dragCounter++;
			this.isDragOver = true;
		},
		onDragOver(e) {
			if (!this.hasDragFiles(e)) {
				return;
			}
			this.isDragOver = true;
		},
		onDragLeave() {
			this.dragCounter = Math.max(0, this.dragCounter - 1);
			if (this.dragCounter === 0) {
				this.isDragOver = false;
			}
		},
		onDrop(e) {
			this.dragCounter = 0;
			this.isDragOver = false;
			const files = e.dataTransfer && e.dataTransfer.files;
			if (!files || !files.length) {
				return;
			}
			this.focus();
			this.$nextTick(() => {
				const selection = window.getSelection();
				if (!selection.rangeCount) {
					if (this.blurRange) {
						selection.addRange(this.blurRange);
					} else {
						this.moveCursorToEnd();
					}
				}
				for (let i = 0; i < files.length; i++) {
					this.insertMediaFile(files[i]);
				}
			});
		},
		hasDragFiles(e) {
			const types = e.dataTransfer && e.dataTransfer.types;
			if (!types) {
				return false;
			}
			return Array.from(types).includes('Files');
		},
		insertMediaFile(file) {
			if (!file) {
				return;
			}
			this.isEmpty = false;
			this.changeStored = false;
			if (file.type && file.type.indexOf('image') !== -1) {
				let imagePush = {
					fileId: this.generateId(),
					file: file,
					url: URL.createObjectURL(file)
				};
				this.imageList[imagePush.fileId] = imagePush;
				let line = this.newLine();
				let imageElement = document.createElement('img');
				imageElement.className = 'chat-image no-text';
				imageElement.src = imagePush.url;
				imageElement.dataset.imgId = imagePush.fileId;
				line.appendChild(imageElement);
				let after = document.createTextNode('\u00A0');
				line.appendChild(after);
				this.selectElement(after, 1);
			} else {
				let filePush = { fileId: this.generateId(), file: file };
				this.fileList[filePush.fileId] = filePush;
				let line = this.newLine();
				let fileElement = this.createFile(filePush);
				line.appendChild(fileElement);
				let after = document.createTextNode('\u00A0');
				line.appendChild(after);
				this.selectElement(after, 1);
			}
		},
		moveCursorToEnd() {
			const content = this.$refs.content;
			const range = document.createRange();
			const selection = window.getSelection();
			range.selectNodeContents(content);
			range.collapse(false);
			selection.removeAllRanges();
			selection.addRange(range);
			this.focus();
			this.updateRange();
		},
		selectElement(element, endOffset) {
			let selection = window.getSelection();
			// 插入元素可能不是立即执行的，vue可能会在插入元素后再更新dom
			this.$nextTick(() => {
				let t1 = document.createRange();
				t1.setStart(element, 0);
				t1.setEnd(element, endOffset || 0);
				if (element.firstChild) {
					t1.selectNodeContents(element.firstChild);
				}
				t1.collapse();
				selection.removeAllRanges();
				selection.addRange(t1);
				// 需要时自动聚焦
				if (element.focus) {
					element.focus();
				}
			})
		},
		onCompositionEnd(e) {
			this.compositionFlag = false;
			this.onEditorInput(e);
		},
		onKeydown(e) {
			if (e.keyCode === 13) {
				e.preventDefault();
				e.stopPropagation();
				if (this.atIng) {
					this.$refs.atBox.select();
					return;
				}
				if (e.ctrlKey) {
					let line = this.newLine();
					let after = document.createTextNode('\u00A0');
					line.appendChild(after);
					this.selectElement(line.childNodes[0], 0);
				} else {
					// 中文输入标记
					if (this.compositionFlag) {
						return;
					}
					this.submit();
				}
				return;
			}
			// 删除键
			if (e.keyCode === 8) {
				// 等待dom更新
				setTimeout(() => {
					let s = this.$refs.content.innerHTML.trim();
					// 空dom时，需要刷新dom
					if (s === '' || s === '<br>' || s === '<div>&nbsp;</div>') {
						// 拼接随机长度的空格，以刷新dom
						this.empty();
						this.isEmpty = true;
						this.selectElement(this.$refs.content);
					} else {
						this.isEmpty = false;
					}
				})
			}
			// at框打开时，上下键移动特殊处理
			if (this.atIng) {
				if (e.keyCode === 38) {
					e.preventDefault();
					e.stopPropagation();
					this.$refs.atBox.moveUp();
				}
				if (e.keyCode === 40) {
					e.preventDefault();
					e.stopPropagation();
					this.$refs.atBox.moveDown();
				}
			}

		},
		onAtSelect(member) {
			this.atIng = false;
			// 选中输入的 @xx 符
			let blurRange = this.blurRange;
			let endContainer = blurRange.endContainer
			let startOffset = endContainer.data.indexOf("@" + this.atSearchText);
			let endOffset = startOffset + this.atSearchText.length + 1;
			blurRange.setStart(blurRange.endContainer, startOffset);
			blurRange.setEnd(blurRange.endContainer, endOffset);
			blurRange.deleteContents()
			blurRange.collapse();
			this.focus();
			// 创建元素节点
			let element = document.createElement('SPAN')
			element.className = "chat-at-user";
			element.dataset.id = member.userId;
			element.contentEditable = 'false'
			element.innerText = `@${member.showNickName}`
			blurRange.insertNode(element)
			// 光标移动到末尾
			blurRange.collapse()

			// 插入空格
			let textNode = document.createTextNode('\u00A0');
			blurRange.insertNode(textNode);

			blurRange.collapse()
			this.atSearchText = "";
			this.selectElement(textNode, 1);
		},
		onEditorInput(e) {
			this.isEmpty = false;
			this.changeStored = false;
			// 通知父组件正在输入(接待会话防重复回复心跳用,节流在父组件)
			this.$emit('typing');
			if (this.$props.groupMembers && !this.compositionFlag) {
				let selection = window.getSelection()
				if (!selection || selection.rangeCount === 0) return;
				let range = selection.getRangeAt(0);
				// 截取@后面的名称作为过滤条件，并以空格结束
				let endContainer = range.endContainer;
				let endOffset = range.endOffset;
				let textContent = endContainer.textContent;
				let startIndex = -1;
				for (let i = endOffset; i >= 0; i--) {
					if (textContent[i] === '@') {
						startIndex = i;
						break;
					}
				}
				// 没有at符号，则关闭弹窗
				if (startIndex === -1) {
					this.$refs.atBox.close();
					return;
				}

				let endIndex = endOffset;
				for (let i = endOffset; i < textContent.length; i++) {
					if (textContent[i] === ' ') {
						endIndex = i;
						break;
					}
				}
				this.atSearchText = textContent.substring(startIndex + 1, endIndex).trim();
				// 打开选择弹窗
				if (this.atSearchText == '') {
					this.showAtBox(e)
				}
			}
		},
		onClickInput() {
			this.updateRange();
		},
		onKeyup() {
			this.updateRange();
		},
		onMousedown() {
			if (this.atIng) {
				this.$refs.atBox.close();
				this.atIng = false;
			}
		},
		insertEmoji(emojiText) {
			let emojiElement = document.createElement('img');
			emojiElement.className = 'emoji-normal no-text';
			emojiElement.dataset.emojiCode = emojiText;
			emojiElement.src = this.$emo.textToUrl(emojiText);

			let blurRange = this.blurRange;
			if (!blurRange) {
				this.focus();
				this.updateRange();
				blurRange = this.blurRange;
			}
			if (blurRange.startContainer !== blurRange.endContainer || blurRange.startOffset !== blurRange.endOffset) {
				blurRange.deleteContents();
			}
			blurRange.insertNode(emojiElement);
			blurRange.collapse()

			let textNode = document.createTextNode('\u200B');
			blurRange.insertNode(textNode)
			blurRange.collapse()

			this.selectElement(textNode);
			this.isEmpty = false;
		},
		// 快捷回复: 在光标处插入纯文本(换行转<br>),不直接发送,供二次编辑
		insertText(text) {
			let blurRange = this.blurRange;
			if (!blurRange) {
				this.focus();
				this.updateRange();
				blurRange = this.blurRange;
			}
			if (blurRange.startContainer !== blurRange.endContainer || blurRange.startOffset !== blurRange.endOffset) {
				blurRange.deleteContents();
			}
			const lines = String(text == null ? '' : text).split('\n');
			const frag = document.createDocumentFragment();
			lines.forEach((line, i) => {
				if (i > 0) {
					frag.appendChild(document.createElement('br'));
				}
				frag.appendChild(document.createTextNode(line));
			});
			blurRange.insertNode(frag);
			blurRange.collapse(false);
			let caret = document.createTextNode('​');
			blurRange.insertNode(caret);
			blurRange.collapse(false);
			this.selectElement(caret);
			this.isEmpty = false;
			this.focus();
		},
		generateId() {
			return this.currentId++;
		},
		createFile(filePush) {
			let file = filePush.file;
			let fileId = filePush.fileId;
			let container = document.createElement('div');
			container.className = 'chat-file-container no-text';
			container.contentEditable = 'false';
			container.dataset.fileId = fileId;

			let left = document.createElement('div');
			left.className = 'file-position-left';
			container.appendChild(left);

			let icon = document.createElement('div');
			icon.className = 'el-icon-document';
			left.appendChild(icon);

			let right = document.createElement('div');
			right.className = 'file-position-right';
			container.appendChild(right);

			let fileName = document.createElement('div');
			fileName.className = 'file-name';
			fileName.innerText = file.name;

			let fileSize = document.createElement('div');
			fileSize.className = 'file-size';
			fileSize.innerText = this.sizeConvert(file.size);

			right.appendChild(fileName);
			right.appendChild(fileSize);

			return container;
		},
		sizeConvert(len) {
			if (len < 1024) {
				return len + 'B';
			} else if (len < 1024 * 1024) {
				return (len / 1024).toFixed(2) + 'KB';
			} else if (len < 1024 * 1024 * 1024) {
				return (len / 1024 / 1024).toFixed(2) + 'MB';
			} else {
				return (len / 1024 / 1024 / 1024).toFixed(2) + 'GB';
			}
		},
		updateRange() {
			let selection = window.getSelection();
			if (selection && selection.rangeCount > 0) {
				this.blurRange = selection.getRangeAt(0);
			}
		},
		newLine() {
			let selection = window.getSelection();
			let divElement = document.createElement('div');
			if (!selection || selection.rangeCount === 0) {
				divElement.innerHTML = '';
				this.$refs.content.append(divElement);
				return divElement;
			}
			let range = selection.getRangeAt(0);
			let endContainer = range.endContainer;
			let parentElement = endContainer.parentElement;
			if (parentElement.parentElement === this.$refs.content) {
				divElement.innerHTML = endContainer.textContent.substring(range.endOffset).trim();
				endContainer.textContent = endContainer.textContent.substring(0, range.endOffset);
				// 插入到当前div（当前行）后面
				parentElement.insertAdjacentElement('afterend', divElement);
			} else {
				divElement.innerHTML = '';
				this.$refs.content.append(divElement);
			}
			return divElement;
		},
		clear() {
			this.empty();
			this.imageList = [];
			this.fileList = [];
			this.$refs.atBox.close();
		},
		empty() {
			this.$refs.content.innerHTML = "";
			let line = this.newLine();
			let after = document.createTextNode('\u00A0');
			line.appendChild(after);
			this.$nextTick(() => this.selectElement(after));
		},
		showAtBox(e) {
			this.atIng = true;
			// show之后会自动更新当前搜索的text
			// this.atSearchText = "";
			let selection = window.getSelection()
			if (!selection || selection.rangeCount === 0) return
			let range = selection.getRangeAt(0)
			// 光标所在坐标
			let pos = range.getBoundingClientRect();
			this.$refs.atBox.open({
				x: pos.x,
				y: pos.y
			})
			// 记录光标所在位置
			this.updateRange();
		},
		submit() {
			let nodes = this.$refs.content.childNodes;
			let fullList = [];
			let tempText = '';
			let atUserIds = [];
			let each = (nodes) => {
				for (let i = 0; i < nodes.length; i++) {
					let node = nodes[i];
					if (!node) {
						continue;
					}
					if (node.nodeType === 3) {
						tempText += node.textContent;
						continue;
					}
					let nodeName = node.nodeName.toLowerCase();
					if (nodeName === 'script') {
						continue;
					}
					let text = tempText.trim();
					if (nodeName === 'img') {
						let imgId = node.dataset.imgId;
						if (imgId) {
							if (text) {
								fullList.push({
									type: 'text',
									content: text,
									atUserIds: atUserIds
								})
								tempText = '';
								atUserIds = []
							}
							fullList.push({
								type: 'image',
								content: this.imageList[imgId]
							})
						} else {
							let emojiCode = node.dataset.emojiCode;
							tempText += emojiCode;
						}
					} else if (nodeName === 'div') {
						let fileId = node.dataset.fileId
						// 文件
						if (fileId) {
							if (text) {
								fullList.push({
									type: 'text',
									content: text,
									atUserIds: atUserIds
								})
								tempText = '';
								atUserIds = []
							}
							fullList.push({
								type: 'file',
								content: this.fileList[fileId]
							})
						} else {
							tempText += '\n';
							each(node.childNodes);
						}
					} else if (nodeName === 'span') {
						if (node.dataset.id) {
							tempText += node.innerHTML;
							atUserIds.push(node.dataset.id)
						} else if (node.outerHTML) {
							tempText += node.outerHTML;
						}
					}
				}
			}
			each(nodes)
			let text = tempText.replace(/\u200B/g, '').trim();
			if (text !== '') {
				fullList.push({
					type: 'text',
					content: text,
					atUserIds: atUserIds
				})
			}
			this.$emit('submit', fullList);
		},
		focus() {
			this.$refs.content.focus();
		},
		// 外部（如用户名片「@TA」）主动在编辑器末尾插入一个 @提及
		insertMention(member) {
			if (!member || !member.id) {
				return;
			}
			this.focus();
			let range = document.createRange();
			range.selectNodeContents(this.$refs.content);
			range.collapse(false);
			let element = document.createElement('SPAN');
			element.className = "chat-at-user";
			element.dataset.id = member.id;
			element.contentEditable = 'false';
			element.innerText = `@${member.name || ''}`;
			range.insertNode(element);
			range.collapse();
			let textNode = document.createTextNode('\u00A0');
			range.insertNode(textNode);
			range.collapse();
			this.isEmpty = false;
			this.selectElement(textNode, 1);
			this.updateRange();
		}

	}
}
</script>

<style lang="scss">
.chat-input-area {
	width: 100%;
	height: 100%;
	position: relative;

	&.is-dragover {
		.edit-container {
			outline: 2px dashed #587ff0;
			outline-offset: -2px;
			background: rgba(88, 127, 240, 0.06);
		}

		.edit-container>div:nth-of-type(1):after {
			content: none;
		}
	}

	.drag-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 10;
		display: flex;
		align-items: center;
		justify-content: center;
		pointer-events: none;
		color: #587ff0;
		font-size: var(--im-font-size);
		font-weight: 600;
		background: rgba(88, 127, 240, 0.08);
	}

	.edit-container {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		outline: none;
		padding: 5px;
		line-height: 26px;
		font-size: var(--im-font-size);
		text-align: left;
		overflow-y: auto;
		white-space: pre-wrap;

		// 单独一行时，无法在前面输入的bug
		>div:before {
			content: "\00a0";
			font-size: 14px;
			position: absolute;
			top: 0;
			left: 0;
		}

		.chat-image {
			display: block;
			max-width: 200px;
			max-height: 100px;
			border: 1px solid #e6e6e6;
			cursor: pointer;
		}

		.chat-file-container {
			max-width: 65%;
			padding: 10px;
			border: 2px solid #587ff0;
			display: flex;
			background: #eeeC;
			border-radius: 10px;

			.file-position-left {
				display: flex;
				width: 80px;
				justify-content: center;
				align-items: center;

				.el-icon-document {
					font-size: 40px;
					text-align: center;
					color: #d42e07;
				}
			}

			.file-position-right {
				flex: 1;

				.file-name {
					font-size: 16px;
					font-weight: 600;
					color: #66b1ff;
				}

				.file-size {
					font-size: 14px;
					font-weight: 600;
				}
			}
		}

		.chat-at-user {
			color: #00f;
			border-radius: 3px;
		}
	}

	.edit-container>div:nth-of-type(1):after {
		content: '请输入消息（按Ctrl+Enter键换行）';
		color: gray;
	}

	.edit-container.not-empty>div:nth-of-type(1):after {
		content: none;
	}

}
</style>
